module.exports = __webpack_public_path__ + "img/icon_account_verification.907f1616.png";